<template>
  <v-dialog v-model="visible" scrollable persistent max-width="700" @keydown.esc="cancelForm()">
    <v-card>
      <v-card-title class="title">
        {{ title }}
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-subtitle><small>(*) indica campos requeridos</small></v-card-subtitle>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="recepcionarForm" v-model="validations.isValid">
          <v-container class="px-0" fluid>
            <v-row>
              <v-col>
                <v-spacer></v-spacer>
                <v-row class="my-4">
                  <h3 class="justify-center">Reconocimiento de la matrícula o bastidor</h3>
                  <v-spacer></v-spacer>
                </v-row>
                <v-row>
                  <v-file-input
                  label="Capturar foto"
                  accept="image/*"
                  capture="environment"
                  prepend-icon="mdi-camera"
                  @change="onFileChange"
                  outlined
                ></v-file-input>
                </v-row>
                <!---
                <v-select
                  v-model="fields.transporte"
                  :items="['Grua', 'Cliente']"
                  label="Transporte*"
                  :rules="validations.transporte"
                  :error-messages="errors.transporte"
                  required
                  outlined
                ></v-select>
                <v-text-field
                  v-if="fields.transporte === 'Grua'"
                  v-model="fields.empresaGrua"
                  label="Empresa de la Grua*"
                  :rules="validations.empresaGrua"
                  :error-messages="errors.empresaGrua"
                  required
                  outlined
                ></v-text-field>
                <v-text-field
                  v-model="fields.ubicacion"
                  :rules="validations.ubicacion"
                  :error-messages="errors.ubicacion"
                  label="Ubicacion*"
                  required
                  outlined
                ></v-text-field>
                <v-text-field
                  v-model="fields.km"
                  :rules="validations.km"
                  :error-messages="errors.km"
                  label="KM*"
                  required
                  outlined
                ></v-text-field>
                <v-select
                  v-model="fields.matriculado"
                  :items="['Si', 'No']"
                  label="¿Vehículo matriculado?*"
                  :rules="validations.matriculado"
                  :error-messages="errors.matriculado"
                  required
                  outlined
                ></v-select>
                <v-text-field
                  v-if="fields.matriculado === 'Si'"
                  v-model="fields.matricula"
                  label="Matrícula*"
                  :rules="validations.matricula"
                  :error-messages="errors.matricula"
                  required
                  outlined
                ></v-text-field>
                <v-select
                  v-model="fields.estadoVehiculo"
                  :items="['Ok', 'Con daños']"
                  label="Estado del vehículo*"
                  :rules="validations.estadoVehiculo"
                  :error-messages="errors.estadoVehiculo"
                  required
                  outlined
                ></v-select>
                <v-text-field
                  v-if="fields.estadoVehiculo === 'Con daños'"
                  v-model="fields.observacion"
                  label="Observación de daños*"
                  :rules="validations.observacion"
                  :error-messages="errors.observacion"
                  required
                  outlined
                ></v-text-field>
                <v-checkbox
                  v-model="fields.chalecos"
                  label="Chalecos"
                  :rules="validations.chalecos"
                  :error-messages="errors.chalecos"
                  outlined
                ></v-checkbox>
                <v-checkbox
                  v-model="fields.luzEmergencia"
                  label="Luz de emergencia"
                  :rules="validations.luzEmergencia"
                  :error-messages="errors.luzEmergencia"
                  outlined
                ></v-checkbox>
                <v-checkbox
                  v-model="fields.triangulos"
                  label="Triángulos"
                  :rules="validations.triangulos"
                  :error-messages="errors.triangulos"
                  outlined
                ></v-checkbox>
                -->
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="loading" @click="cancelForm()" class="grey--text" light text>Cancelar</v-btn>
        <v-btn :loading="loading" :disabled="saveIsDisabled" @click="saveForm()" color="primary" text>Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import _ from 'lodash'
// import UbicacionService from '../../services/UbicacionService'

export default {
  props: {
    value: null
  },

  data: () => ({
    visible: true,
    loading: false,
    visibleAsignacionForm: false,

    // campos del formulario
    user: null,

    fields: {
      transporte: null,
      empresaGrua: null,
      ubicacion: null,
      km: null,
      matriculado: null,
      matricula: null,
      estadoVehiculo: null,
      observacion: null,
      chalecos: false,
      luzEmergencia: false,
      triangulos: false,
      foto: null
    },

    // validaciones
    validations: {
      isValid: true,
      transporte: [
        (v) => !!v || 'Debe seleccionar un tipo de transporte.'
      ],
      empresaGrua: [
        (v) => !!v || 'Debe proporcionar el nombre de la empresa de la grua.'
      ],
      ubicacion: [
        (v) => !!v || 'Debe proporcionar una ubicacion.'
      ],
      km: [
        (v) => !!v || 'Debe proporcionar el kilometraje.'
      ],
      matriculado: [
        (v) => !!v || 'Debe indicar si el vehículo está matriculado.'
      ],
      matricula: [
        (v) => !!v || 'Debe proporcionar la matrícula del vehículo.'
      ],
      estadoVehiculo: [
        (v) => !!v || 'Debe seleccionar el estado del vehículo.'
      ],
      observacion: [
        (v) => !!v || 'Debe proporcionar una observación de los daños.'
      ],
      chalecos: [],
      luzEmergencia: [],
      triangulos: []
    },

    // errores
    errors: {
      transporte: [],
      empresaGrua: [],
      ubicacion: [],
      km: [],
      matriculado: [],
      matricula: [],
      estadoVehiculo: [],
      observacion: [],
      chalecos: [],
      luzEmergencia: [],
      triangulos: []
    }
  }),

  async created () {
    /* if (this.value) {
      this.loading = true
      await this.$store.dispatch('VIEW_USER', { ...this.value, expand: 'asignacion_list' }).then(result => {
        this.user = Object.assign({}, this.value)
        this.userState.list.push(this.user)
        this.fields = Object.assign({}, result)
        this.loading = false
      })
    } */
  },

  methods: {
    saveForm () {
      console.log('Formulario guardado:', this.fields)
    },
    cancelForm () {
      this.$emit('cancel')
    },
    onFileChange (file) {
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.fields.foto = e.target.result
          console.log('Foto cargada:', this.fields.foto)
        }
        reader.readAsDataURL(file)
      }
    }
  },

  computed: {
    isNewRecord () {
      return !this.value
    },
    title () {
      return this.isNewRecord ? 'Check Primera Recepcion' : 'Check Primera Recepcion'
    },
    saveIsDisabled () {
      return this.loading || !this.fields.ubicacion || !this.fields.km || !this.fields.transporte || !this.fields.estadoVehiculo || (this.fields.transporte === 'Grua' && !this.fields.empresaGrua) || (this.fields.matriculado === 'Si' && !this.fields.matricula) || (this.fields.estadoVehiculo === 'Con daños' && !this.fields.observacion)
    }
  }
}
</script>
